import React, { useState } from "react"
import classNames from "classnames"
import { FaCheckCircle, FaInfoCircle, FaTimes } from "react-icons/fa"

type BannerKind = "information" | "success" | "error"

export interface BannerProps {
  text: string
  kind?: BannerKind
  onHide?: () => void
}
const getIcon = (kind?: BannerKind) => {
  switch (kind) {
    case "success":
      return FaCheckCircle
    case "information":
    case "error":
    default:
      return FaInfoCircle
  }
}

export const Banner = ({
  text,
  kind = "information",
  onHide = () => {},
}: BannerProps) => {
  const [isClosed, setIsClosed] = useState(false)

  const className = classNames({
    "flex items-center justify-between w-full gap-4 p-4 rounded pointer-events-auto":
      true,
    "bg-system-message-success-bg text-system-message-success-text":
      kind === "success",
    "bg-system-message-information-bg text-system-message-information-text":
      kind === "information",
    "bg-system-message-error-bg text-system-message-error-text":
      kind === "error",
  })

  const Icon = getIcon(kind as BannerKind)

  return (
    !isClosed && (
      <div className={className}>
        <Icon className="flex h-4 w-4 shrink-0" />
        <span className="grow text-sm leading-5">{text}</span>
        <FaTimes
          className="flex h-5 w-5 shrink-0 cursor-pointer justify-center self-start p-1 text-gray-500 hover:text-inherit"
          onClick={(): void => {
            setIsClosed(true)
            onHide()
          }}
        />
      </div>
    )
  )
}
